import type { Router, RouteLocation, RouteLocationRaw } from 'vue-router'

const PROXY_FUNCTIONS = ['push', 'replace']

export function useLocaleRouter(): Router {
  const router = useRouter()
  const localePath = useLocalePath()

  return new Proxy(router, {
    get(target, prop) {
      if (typeof prop === 'string' && PROXY_FUNCTIONS.includes(prop)) {
        return (route: RouteLocation) => Reflect.get(target, prop)(localePath(route as RouteLocationRaw))
      }
      return Reflect.get(target, prop)
    },
  })
}
